import { Component, OnInit } from '@angular/core';
import {FETCH_PRODUCT_DETAIL_REQUESTED} from "./detail.actions";
import store from "../../../store/store.module";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {

  public values;
  constructor(private router: Router, private route: ActivatedRoute) { }
  ngOnInit() {
    store.dispatch({ type: FETCH_PRODUCT_DETAIL_REQUESTED, data: this.route.snapshot.paramMap.get('id') });
    let subscribeProduct = store.subscribe(() => {
      if ((store as any).getState().Product.detail.fetched) {
        this.values =  [{
          sku: (store as any).getState().Product.detail.data.sku,
          price: (store as any).getState().Product.detail.data.original_price,
          stPrice: (store as any).getState().Product.detail.data.price,
          size: (store as any).getState().Product.detail.data.size
        }];
        console.log(this.values);
        subscribeProduct();
      }
    });
  }
}
